import { Component } from '@angular/core';

@Component({
  selector: 'app-student-revision-note',
  imports: [],
  templateUrl: './student-revision-note.component.html',
  styleUrl: './student-revision-note.component.css'
})
export class StudentRevisionNoteComponent {

}
